import { IInsuranceInfo } from "../../../../../services/api-client/contact-api";
import { IvPatientInfo } from '../../types/iv-patient-info';

export const GetMissingInfoErrorSummary = (patientInfo?: IvPatientInfo, payerId?: string, insuranceInfo?: IInsuranceInfo) => {
    const missingInfo = [];

    const patientContact = patientInfo?.familyMembers?.find(f => f.id === patientInfo?.id);

    if (!patientContact?.firstName) missingInfo.push('Missing patient first name');
    if (!patientContact?.lastName) missingInfo.push('Missing patient last name');
    if (!patientContact?.dateOfBirth) missingInfo.push('Missing patient birth date');

    if (!insuranceInfo?.beginningMonth) missingInfo.push('Missing insurance starting month');
    if (!insuranceInfo?.carrierId) missingInfo.push('Missing insurance company name');
    if (!insuranceInfo?.memberId) missingInfo.push('Missing insurance member ID');

    if (insuranceInfo?.relation !== undefined && insuranceInfo?.relation !== 0) {
        // If the relationship to the insurance subscriber is self (0) then check that we have subscriber info
        if (!insuranceInfo?.subscriberFirstName) missingInfo.push('Missing subscriber first name');
        if (!insuranceInfo?.subscriberLastName) missingInfo.push('Missing subscriber last name');
        if (!insuranceInfo?.subscriberDateOfBirth) missingInfo.push('Missing subscriber birth date');
    }

    if (payerId === 'METLIFE' && !insuranceInfo?.subscriberPostalCode && !patientContact?.address?.zip) {
        // Zip code is required for Metlife verifications
        missingInfo.push('Missing subscriber zip code');
    }

    return missingInfo;
}






